/** Canonical compatible harnesses (must match the backend's allowed set). */
export const SKILL_COMPATIBILITY_OPTIONS = [
  "Claude Code",
  "Claude Cowork",
  "Gemini",
  "Github Copilot",
  "Copilot 365",
  "Copilot Cowork",
  "Hermes",
] as const;

/** Maps a harness value to its brand title (used to pick the right logo). */
const HARNESS_TITLE: Record<string, string> = {
  "Claude Code": "Anthropic",
  "Claude Cowork": "Anthropic",
  Gemini: "Google Gemini",
  "Github Copilot": "GitHub Copilot",
  "GitHub Copilot": "GitHub Copilot",
  "Copilot 365": "Copilot 365",
  "Copilot Cowork": "Copilot Cowork",
  Hermes: "Hermes",
};

export function skillCompatibilityTitle(value: string): string {
  return HARNESS_TITLE[value] ?? "GitHub Copilot";
}
